<template>
<div>404040404</div>
</template>

<script>

    export default {
        data() {
            return {}
        },
        mounted() {

        },
        computed: {},
        methods: {}
    }
</script>

<style lang="scss">

</style>
